import { AtendimentoInput } from 'graphql/types.generated'

import { NovoAtendimentoFormModel } from './model'

export const convertNovoAtendimentoModelToInput = (
  cidadaoId: ID,
  novoAtendimento: NovoAtendimentoFormModel
): AtendimentoInput => ({
  cidadao: cidadaoId,
  equipe: novoAtendimento?.equipe?.id,
  lotacao: novoAtendimento?.lotacao?.id,
  tiposServico: novoAtendimento?.tiposServico,
})
